<button
  *ngIf="style === 'flat'"
  class="action-button"
  [ngClass]="{ fullWidth: fullWidth, enabled: !disabled }"
  mat-flat-button
  (click)="triggerEvent()"
  [disabled]="disabled"
>
  {{ text }}
</button>

<button
  *ngIf="style === 'raised'"
  class="action-button"
  [ngClass]="{ fullWidth: fullWidth, enabled: !disabled }"
  mat-raised-button
  [disabled]="disabled"
  (click)="triggerEvent()"
>
  {{ text }}
</button>
